import { SET_PRODUCTION_SUMMARY_PROJECTS } from '../actions/types';

const initialState = {
    projects: [],
    cityOptions: [],
    isLoaded: false,
};

export default function productionSummaryProjectReducer(state = initialState, action) {
    const { type, payload } = action;
    switch (type) {
        case SET_PRODUCTION_SUMMARY_PROJECTS:
            return {
                ...state,
                projects: payload?.projects || [],
                cityOptions: payload?.cityOptions || [],
                isLoaded: true,
            };
        default:
            return state;
    }
}
